import type { WorkspaceTokenScope } from '@/lib/api';

/** One-line description of what each workspace API token scope allows. */
export const SCOPE_HELP: Record<WorkspaceTokenScope, string> = {
  read: 'Read everything in the workspace. Any write is refused.',
  write:
    'Read, plus import files, edit keys and translations, and run AI translation on every project.',
  admin:
    'Write, plus manage projects, languages, permissions, publish targets, credentials and AI config. Never members or tokens.',
};
